export default "__VITE_ASSET__DKGe4cBh__"